import axios from "axios";
import {API_URL} from "@env";

export const setConsultations = (payload) => {
    return axios.post(API_URL + `/consultation-form`, payload);
}

export const getConsultation = (consId) => {
    return axios.get(API_URL + `/consultation-form/${consId}`);
}